<template>
    <Modal :title="'运费模板编辑'" :width="1400" @on-visible-change="showModal" v-model="show" :closable="false" :mask-closable="false">
        <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
            <el-form ref="freightTpl" inline label-position="right" label-width="120px" :model="freightTpl" :rules="rules">
                <input type="hidden" :model="freightTpl.id" />
                <el-row>
                    <el-col :span="24">
                     <el-form-item label="模板名称" prop="name">
                        <el-input size="small" v-model="freightTpl.name" placeholder="模板名称" style="width: 120px" />
                    </el-form-item>
                     <el-form-item label="别名备注" prop="remark">
                        <el-input size="small" v-model="freightTpl.remark" placeholder="别名备注" style="width: 120px" />
                    </el-form-item>
                    <el-form-item label="选择仓库" prop="warehouseId">
                        <el-select  size="small" v-model="freightTpl.warehouseId" placeholder="地区" style="width: 180px">
                            <el-option v-for="(vl,ky) in warehouses"  :key="vl.id" :value="vl.id" :label="vl.name">{{vl.name}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="地区"  size="small"prop="country">
                        <el-select  size="small" v-model="freightTpl.country" placeholder="地区" style="width: 120px">
                            <el-option v-for="(vl,ky) in areaTypes" :key="ky" :value="ky" :label="vl">{{vl}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="集运类型" prop="airFreight">
                        <el-select  size="small" v-model="freightTpl.airFreight" placeholder="" style="width: 120px">
                            <el-option :value="1" :label="'空运'">空运</el-option>
                            <el-option :value="2" :label="'海快'">海快</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货物类型" prop="productType">
                        <el-select v-model="freightTpl.productType" placeholder="产品类型" style="width: 120px">
                            <el-option v-for="(vl,ky) in productTypes" :key="ky" :value="ky" :label="vl">{{vl}}</el-option>
                        </el-select>
                    </el-form-item>
                   
                    <el-form-item label="计算方式" prop="type">
                        <RadioGroup v-model="freightTpl.type">
                            <Radio :label="1">
                                <span>重量</span>
                            </Radio>
                            <Radio :label="2">
                                <span>体积</span>
                            </Radio>
                        </RadioGroup>
                        <Checkbox v-show="freightTpl.type==1" :true-value="0" :false-value="1" v-model="freightTpl.isVolume">实重来计算</Checkbox>
                        <font color="#f00" v-if="freightTpl.type!=1 ||(freightTpl.type==1 && freightTpl.isVolume==1)">如果计算方式为【重量】，实重的话请勾选，默认为体积重</font>
                    </el-form-item>
                    <el-form-item v-if="freightTpl.type==2||(freightTpl.type==1 &&freightTpl.isVolume==1 )" label="体积重因子" prop="volume">
                        <el-input size="small" v-model="freightTpl.volume" placeholder="体积重因子" style="width:120px" />
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item :label="freightTpl.type==1?'首 重':'首体积'" prop="firstWeight">
                    <el-input size="small" v-model="freightTpl.firstWeight" :placeholder="freightTpl.type==1?'首重kg':'首体积/立方'" style="width: 120px" />{{freightTpl.type==1?'kg':'m3'}}
                </el-form-item>
                <el-form-item label="首金额" prop="firstMoney">
                    <el-input size="small" v-model="freightTpl.firstMoney" placeholder="首重金额" style="width: 120px" />
                </el-form-item>
                <el-form-item :label="freightTpl.type==1?'续 重':'续体积'" prop="secondWeight">
                    <el-input size="small" v-model="freightTpl.secondWeight" :placeholder="freightTpl.type==1?'续重':'续体积'" style="width:120px" />
                    {{freightTpl.type==1?'kg':'m3'}}
                </el-form-item>
                <el-form-item label="续金额" prop="secondMoney">
                    <el-input size="small" v-model="freightTpl.secondMoney" placeholder="续重金额" style="width: 120px" />
                </el-form-item>
                <!-- <el-form-item label="不足续重" prop="shortage">
                    <el-input size="small" v-model="freightTpl.shortage" placeholder="不足续重" style="width: 120px" />
                    <font>*不足续重,则按多少元计算</font>
                </el-form-item> -->
            </el-form>
        </Content>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" :loading="modalLoading" @click="ok">确定</el-button>
        </div>
    </Modal>
</template>
<script>
import Constants from "@/utils/constants"
export default {
    name: 'FreightTpl',
    data() {
        return {
            show: false,

            modalLoading: false,
            productTypes: Constants.productTypes,
            areaTypes: Constants.areaTypes,
            rules: {
                volume:[{required:true,message:"体积重因子不能为空"}],
                name:[{required:true,message:"模板名称不能为空"}],
            	firstMoney:[{required:true,message:"首重费用为空"}],
            	secondMoney:[{required:true,message:"续重费用不能为空"}],
            	firstWeight:[{required:true,message:"首重不能为空"}],
            	secondWeight:[{required:true,message:"首重不能为空"}],
            },
            warehouses: [],
            freightTpl: {
                id:0,
                isVolume: 0,
                type: 1,
                warehouseId:null,
                productType: "P",
                airFreight: 1,
                country: "TW",
            }

        };
    },
    mounted: function() {


    },
    props: [
        'freightTplId',

    ],
    methods: {
        getWarehouses: function() {

            var me = this;
            var params ={current : 1,pageSize:100};
            me.$http.post("/ware/warehouse/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.warehouses = body.obj.list;
                    me.freightTpl.warehouseId=me.warehouses[0].id;

                }

            }, response => {

            });
        },
        showModal(val) {
            if (val) {
                this.freightTpl.id=this.freightTplId;
                this.getDetail();
                if (this.warehouses.length <= 0) {
                    this.getWarehouses();
                }
            } else {
                this.freightTpl.id=0;
            }

        },
        showDialog() {
            this.show = true;
        },
        getDetail: function() {
            if (this.freightTpl.id == null || this.freightTpl.id == undefined || this.freightTpl.id == ""||this.freightTpl.id<=0) return;
            var me = this;
            me.showLoading();
            me.$http.post("/ware/freighttpl/show_" + me.freightTplId + ".action").then(response => {
                var body = response;
                if (body.status == 0) {
                    me.freightTpl = body.obj;

                }
                me.hideLoading();
            }, response => {
                me.hideLoading();
            });
        },

        ok: function() {
            var ok = false;
            this.$refs['freightTpl'].validate((valid) => {
                ok = valid;
                if (valid) {

                } else {
                    this.$Message.error('请认真填写数据');
                }
            })
            if (!ok) return;
            var me = this;

            me.modalLoading = true;
            me.$http.post("/ware/freighttpl/doSave.action", me.freightTpl).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.$Message.success("保存成功！");

                    me.modalEdit = false;
                    me.show=false;
                    me.$emit("ok");


                } else {
                    me.$Message.error("操作异常!" + body.info);
                }
                me.modalLoading = false;
            }, response => {
                me.modalLoading = false;
            });
        },
        cancel: function() {
            this.show=false;
          	this.$emit("cancel")
        }
    }
}
</script>
<style scoped>
</style>